import { signal } from '@angular/core';
import { CountryEnum } from '@partners/constants';
import { TCatalogGraphicOption } from '../model';

export const locationCatalog$$ = signal<TCatalogGraphicOption[]>([
  { key: 'ישראל', value: CountryEnum.israel, icon: 'ico-rounded--cacti' },
  { key: 'אחר', value: CountryEnum.abroad, icon: 'ico-rounded--globe' }
]);
